import React from 'react';
import propTypes from 'prop-types';
import styles from './Loading.module.scss';

const Loading = ({ phrase, customClass }) => {
	return (
		<div className={`${styles['container']} ${customClass}`}>
			<div className={styles['spinner']} />
			<p className={styles.phrase}>Loading {phrase || ''}...</p>
		</div>
	);
};

Loading.propTypes = {
	phrase: propTypes.string,
	customClass: propTypes.string,
};

Loading.defaultProps = {
	phrase: null,
	customClass: '',
};

export default Loading;
